var INFO_EVENTS = {
  CUSTOM_BUTTON_CLICKED: 'CUSTOM_BUTTON_CLICKED',
  SOCIAL_SHARE_BUTTON_CLICKED: 'SOCIAL_SHARE_BUTTON_CLICKED'
};
export default INFO_EVENTS;